const en_common_report = {
    payment_type: "payment type",

    do: {
        "": "delivery order",
        detail: "delivery order details",
    },
    delivery: {
        "": "delivery",
        label: {

        }
    },

    group: {
        "": "group",
        label: {

        }
    },

    hpp: {
        "": "cost of goods sold",
        total: "total cost of goods sold",
        label: {
        }
    },

    purch: {
        "": "purchases",
        label: {

        }
    },
    payment_sales: {
        "": "sales payments",
        label: {

        }
    },
    payment_purch: {
        "": "purchase payments",
        label: {

        }
    },

    return_cus: {
        "": "sales returns",
        total: "total sales return amount",
    },
    return_sup: {
        "": "purchase returns",
        total: "total purchase return amount",
    },

    sales: {
        "": "sales",
        detail: "sales details",
    },
    sales_commission: {
        "": "sales commission",
        total: "total sales commission",
        label: {
            total: "total commission"
        }
    },
    stock_price: {
        "": "inventory value",
        label: {
            nominal: "inventory value",
            total_nominal: "total inventory value",
        },
    },
    so: {
        "": "sales order",
        detail: "sales order details",
        label: {
            type: "SO type",
            status: "SO status",
            status_item: "item status",
        }
    },
}

export default en_common_report;